import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { StripePaymentService } from '../../../shared/services/stripePayment.service';
import { StripePayment } from '../../../shared/models/stripePayment';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { OrganizationServices } from '../../../shared/services/organization.services';

import { Subject } from 'rxjs/Rx';

import { User } from '../../../shared/models/user.model';
import { MatSnackBar, MatTableDataSource, MatPaginator } from '@angular/material';
import { environment } from '../../../../../environments/environment';
import { HeaderTitleService } from 'app/services/header-title.service';

@Component({
  selector: 'eguard-payments-form',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
  providers: [OrganizationServices, StripePaymentService],
  encapsulation: ViewEncapsulation.None
})
export class EguardPaymentsComponent implements OnInit {
  displayedColumns: string[] = ['time', 'caseid', 'ward_name', 'user', 'amount', 'description'];

  private userStateSubscription: Subscription;
  private paymentSubscription: Subscription;

  showPaymentsLoader = true;
  inputValue: any = '';
  userDetails: User;
  done = false;

  error;
  dtOptions: any;
  organizations: any;
  users: any;
  dtTrigger: Subject<any> = new Subject();
  stripePayments: any = [];
  rows = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('myTable') table: any;


  userId: any;
  orgId: any;
  token: string;
  userRole: string;


  constructor(
    private stripePaymentService: StripePaymentService,
    private organizationServices: OrganizationServices,
    private router: Router,
    private cognitoUtil: CognitoUtil,
    public snackBar: MatSnackBar,
    private localUser: LocalUserService,
    private headerService: HeaderTitleService
  ) { }

  ngOnInit(): void {
    this.rows.paginator = this.paginator;
    this.getOrganization();

    this.userId = this.localUser.getUserId();
    this.orgId = this.localUser.getOrganizationId();
    this.userRole = this.localUser.getRole();

    if (this.userRole === 'CLERK' || this.userRole === 'JUDGE') {
      this.getPayments();
    }
    else {
      this.getUserPayments();
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      dom: 'Bfrtip',
      responsive: true,
      buttons: [
        // 'colvis',
        // 'copy',
        // 'csv',
        'pdf',
        'print',
        'excel'
      ],
    };
    setTimeout(() => { this.sendHeaders(); });
  }
  sendHeaders(): void {
    this.headerService.sendHeader('payment', 'Payments')
  }
  getOrganization() {
    this.organizationServices.getOrganizations()
      .subscribe(
        data => {
          this.organizations = data;
        },
        Error => {

        }
      );
  }

  getAllUsers(orgID: string) {
    this.userStateSubscription = this.organizationServices.getUsersInOrganization(orgID)
      .subscribe(
        data => {
          this.users = data;
          this.getPayments();
        },
        Error => { }
      );
  }

  getPayments() {
    this.paymentSubscription = this.stripePaymentService.getStripePayments(this.orgId)
      .subscribe(result => {
        this.fillTable(result);
      },
        Error => {
          this.error = 'This page had an error please refresh if this continues contact support';
          this.snackBar.open(this.error, '', {
            duration: environment.snackBarErrorLength,
          });
        });
  }

  getUserPayments() {
    this.paymentSubscription = this.stripePaymentService.getStripePaymentsByUserId(this.orgId, this.userId)
      .subscribe(result => {
        this.fillTable(result);
      },
        Error => {
          this.error = 'This page had an error please refresh if this continues contact support';
          this.snackBar.open(this.error, '', {
            duration: environment.snackBarErrorLength,
          });
        });
  }

  fillTable(result) {

    result.sort(function (x, y) {
      return y.time - x.time;
    });

    this.showResults(result);
  }

  showResults(result) {
    for (let payment of result) {

      if (this.users != undefined) {
        for (let user of this.users) {
          if (payment.user_id === user.id) {
            payment.user = user.first_name + ' ' + user.last_name;
          }
        }
      }

      if (this.organizations != undefined) {
        for (let orgnization of this.organizations) {
          if (payment.organization_id === orgnization.id) {
            payment.organization = orgnization.name;
          }
        }
      }

    }
    this.stripePayments = result;
    this.rows.data = result;
    this.showPaymentsLoader = false;
    this.dtTrigger.next();
  }

  centsToDollars(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // filterResults(event) {
  //   const val = event.target.value.toLowerCase();

  //   const filteredData = this.stripePayments.filter((payment) => {
  //     return (payment.user && payment.user.toLowerCase().indexOf(val) !== -1)
  //       || (payment.amount && this.centsToDollars(payment.amount).toLowerCase().indexOf(val) !== -1)
  //       || (payment.id && payment.id.toLowerCase().indexOf(val) !== -1)
  //       || (payment.organization && payment.organization.toLowerCase().indexOf(val) !== -1)
  //       || !val;
  //   });

  //   this.rows = filteredData;
  //   // this.table.offset = 0;
  // }

  openCase(row) {
    this.router.navigate(['case', this.orgId, row]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.rows.filter = filterValue;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/payments/payments.component.ts